// banner type=1

import * as get from '@ccforeverd/tool-get'
import mixin, { style } from './mixin'

const { client } = get.query()
const isClient10 = parseInt(client) === 10 // 办公助手公众号

export default {
  mixins: [mixin],

  data () {
    return {
      swiperOptions: {
        pagination: {
          el: `.${style.bannerMainPagination}`,
          bulletClass: style.bannerMainPaginationItem,
          bulletActiveClass: style.bannerMainPaginationactivie
        },
        autoplay: true,
        delay: 3000,
        on: {
          slideChange () {
            
          }
        }
      }
    }
  },

  methods: {
    onBannerClick (item, index) {
      this.onClick(item)
    }
  },

  mounted () {
  },

  render () {
    const {
      list, // from mixin
      onBannerClick, // from this.methods
      swiperOptions // from this.data
    } = this

    return (
      list.length && <section class={style.banner}>
        <swiper class={style.bannerMain} options={swiperOptions}>
          {
            list.map((item, index) => {
              return (
                <swiper-slide>
                  <div class={style.bannerMainItem} onClick={() => onBannerClick(item, index)}>
                    <img class={style.img1} src={item.imageUrl} alt={item.title}/>
                  </div>
                </swiper-slide>
              )
            })
          }
          <div class={style.bannerMainPagination} slot="pagination"></div>
        </swiper>
      </section>
    )
  }
}
